var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics"},[_c('div',{staticClass:"newTime"},[_vm._v("本页更新于:"+_vm._s(_vm.pageTime))]),_c('Total'),_c('div',{staticClass:"list-content bottom_distance"},[_c('Histogram')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }